import { clsx } from "clsx";
import type { HTMLAttributes } from "react";

export function Section({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <section className={clsx("mx-auto w-full max-w-5xl px-4 py-8 sm:px-6", className)} {...props} />;
}
